<div mat-dialog-draggable-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
	<a class="float-right btnClose" (click)="cerrarPopup()"><i class="fal fa-times" style="cursor: pointer;"></i></a>
	<div *ngIf="informacionPunto.tipo !== 'vehiculo'" class="titulo">
		<i class="fal fa-barcode-alt" id="ico"></i>
		<span class="usuario">IMEI:&nbsp;{{informacionPunto.datos.imei}}</span>
	</div>
	<div *ngIf="informacionPunto.tipo == 'vehiculo'" class="titulo">
		<i class="fal fa-user" id="ico"></i>
		<span class="usuario">Usuario:&nbsp;{{informacionPunto.datos.descripcion}}</span>
	</div>
</div>
<mat-card class="mt-2">
	<div class="row">
		<div class="col col-sm-12 col-md-12 col-lg-12 contenido" style="text-align: right;">
			<span><b>{{informacionPunto.numeroActual}}</b>/<b>{{informacionPunto.longitud}}</b></span>
		</div>
		<!-- SECCION ACTIVO -->
		<div *ngIf="informacionPunto.tipo == 'activo'" class="col col-sm-12 col-md-12 col-lg-12 contenido">
			<span><i
					class="fal fa-align-left"></i><b>&nbsp;Descripción:</b>&nbsp;{{informacionPunto.datos.descripcion}}</span><br>
			<span><i
					class="fal fa-credit-card-front"></i><b>&nbsp;Económico:</b>&nbsp;{{informacionPunto.datos.economico}}</span><br>
			<span><i class="fal fa-barcode-alt"></i><b>&nbsp;Número de
					serie:</b>&nbsp;{{informacionPunto.datos.numeroSerie}}</span><br>
			<span><i
					class="fal fa-power-off"></i><b>&nbsp;Estatus</b>&nbsp;{{informacionPunto.datos.estatus}}</span><br>
			<span><i class="fal fa-location"></i><b>&nbsp;GPS:</b>&nbsp;{{informacionPunto.datos.gps}}&nbsp;</span><br>
			<span><i
					class="fal fa-signal-stream"></i><b>&nbsp;Modelo:</b>&nbsp;{{informacionPunto.datos.modelo}}</span><br>
			<span><i class="fal fal fa-calendar-alt"></i><b>&nbsp;Fecha y
					hora:</b>&nbsp;{{informacionPunto.datos.fechaHora}}</span><br>
			<span><i
					class="fal fa-building"></i><b>&nbsp;Cliente:</b>&nbsp;{{informacionPunto.datos.cliente}}</span><br>
			<span><i class="fal fa-location-arrow"></i><b>&nbsp;Ubicación:</b>&nbsp;[&nbsp;{{informacionPunto.datos.lat
				| number: '1.1-4'}},&nbsp;&nbsp;{{informacionPunto.datos.lng | number: '1.1-4'}}&nbsp;]</span><br>
		</div>
		<!-- SECCION TELEFONO -->
		<div *ngIf="informacionPunto.tipo == 'telefono'" class="col col-sm-12 col-md-12 col-lg-12 contenido">
			<span><i
					class="fal fa-align-left"></i><b>&nbsp;Descripción:</b>&nbsp;{{informacionPunto.datos.descripcion}}</span><br>
			<span><i
					class="fal fa-credit-card-front"></i><b>&nbsp;Económico:</b>&nbsp;{{informacionPunto.datos.economico}}</span><br>
			<span><i class="fal fa-barcode-alt"></i><b>&nbsp;Número de
					serie:</b>&nbsp;{{informacionPunto.datos.numeroSerie}}</span><br>
			<span><i
					class="fal fa-power-off"></i><b>&nbsp;Estatus:</b>&nbsp;{{informacionPunto.datos.estatus}}</span><br>
			<span><i class="fal fa-location"></i><b>&nbsp;GPS:</b>&nbsp;{{informacionPunto.datos.gps}}&nbsp;</span><br>
			<span><i
					class="fal fa-signal-stream"></i><b>&nbsp;Modelo:</b>&nbsp;{{informacionPunto.datos.modelo}}</span><br>
			<span><i class="fal fal fa-calendar-alt"></i><b>&nbsp;Fecha y
					hora:</b>&nbsp;{{informacionPunto.datos.fechaHora}}</span><br>
			<span><i
					class="fal fa-building"></i><b>&nbsp;Cliente:</b>&nbsp;{{informacionPunto.datos.cliente}}</span><br>
			<span><i class="fal fa-location-arrow"></i><b>&nbsp;Ubicación:</b>&nbsp;[&nbsp;{{informacionPunto.datos.lat
				| number: '1.1-4'}},&nbsp;&nbsp;{{informacionPunto.datos.lng | number: '1.1-4'}}&nbsp;]</span><br>
		</div>
		<!-- SECCION VEHICULO -->
		<div *ngIf="informacionPunto.tipo == 'vehiculo'" class="col col-sm-12 col-md-12 col-lg-12 contenido">
			<span><i
					class="fal fa-barcode-alt"></i><b>&nbsp;Placa:</b>&nbsp;{{informacionPunto.datos.placas}}</span><br>
			<span><i
					class="fal fa-credit-card-front"></i><b>&nbsp;Económico:</b>&nbsp;{{informacionPunto.datos.economico}}</span><br>
			<span><i class="fal fa-trademark"></i><b>&nbsp;Marca:</b>&nbsp;{{informacionPunto.datos.marca}}</span><br>
			<span><i class="fal fa-car"></i><b>&nbsp;Modelo:</b>&nbsp;{{informacionPunto.datos.modelo}}</span><br>
			<span><i class="fal fa-power-off"></i><b>&nbsp;Ignición:</b>&nbsp;{{informacionPunto.datos.ignicion}}</span><br>
			<span><i
					class="fal fa-tachometer-alt-fast"></i><b>&nbsp;Velocidad:</b>&nbsp;{{informacionPunto.datos.velocidad}}&nbsp;km/h</span><br>
			<span><i class="fal fa-calendar"></i><b>&nbsp;Fecha y
					hora:</b>&nbsp;{{informacionPunto.datos.fecha}}</span><br>
			<span><i class="fal fa-location-arrow"></i><b>&nbsp;Ubicación:</b>&nbsp;[&nbsp;{{informacionPunto.datos.lat
				| number: '1.1-4'}},&nbsp;&nbsp;{{informacionPunto.datos.lng | number: '1.1-4'}}&nbsp;]</span><br>
		</div>
		<div class="col col-sm-12 col-md-12 col-lg-12" style="text-align: right;">
			<a (click)="historicoStreetView()">
				<span class="fal fa-street-view" style="font-size: 1.5vw;"></span>
			</a>
		</div>
	</div>
</mat-card>
